<template>
  <cytomine-modal :active="active" :title="$t('new-folder')" @close="close">
    <div class="field">
      <label class="label">{{ $t('folder-name') }}</label>
      <b-input
        ref="nameInput"
        v-model="name"
        :placeholder="$t('folder-name')"
        :disabled="loading"
        @keyup.enter.native="create"
      />
    </div>

    <template #footer>
      <button class="button is-outlined" type="button" :disabled="loading" @click="close">
        {{ $t('button-cancel') }}
      </button>
      <button class="button is-primary" type="button" :class="{ 'is-loading': loading }"
        :disabled="loading || !name.trim()" @click="create">
        {{ $t('button-create-folder') }}
      </button>
    </template>
  </cytomine-modal>
</template>

<script>
import CytomineModal from '../utils/CytomineModal.vue';

export default {
  name: 'NewFolderModal',
  components: { CytomineModal },
  props: {
    active: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data() {
    return { name: '' };
  },
  watch: {
    active(value) {
      if (!value) return;
      this.name = '';
      this.$nextTick(() => this.$refs.nameInput && this.$refs.nameInput.focus());
    }
  },
  methods: {
    create() {
      if (this.loading || !this.name.trim()) return;
      this.$emit('create', this.name.trim());
    },
    close() {
      if (!this.loading) this.$emit('update:active', false);
    }
  }
};
</script>
